export type OpenSettingsDetail = {
  tab?: string
  organizationId?: string
  focusSection?: string
  /** Alias accepted by Activity / older callers; mapped to focusSection. */
  section?: string
}

export function openSettings(detail: OpenSettingsDetail = {}) {
  const tab =
    detail.tab === 'organization' || detail.tab === 'workspaces'
      ? 'organizations'
      : detail.tab
  const focusSection = detail.focusSection || detail.section
  window.dispatchEvent(
    new CustomEvent('open-settings', {
      detail: {
        tab,
        organizationId: detail.organizationId,
        focusSection,
      },
    })
  )
}

export function openAccountPasswordSettings() {
  openSettings({ tab: 'account', focusSection: 'password' })
}

/** Workspace Settings > Basecamp > Listening (webhook enable toggles). */
export function openBasecampListeningSettings(organizationId?: string) {
  openSettings({
    tab: 'organizations',
    focusSection: 'basecamp-listening',
    organizationId,
  })
}

/** Workspace Settings > active workspace > Extensions list (rail +). */
export function openWorkspaceExtensionsSettings(organizationId?: string) {
  openSettings({
    tab: 'organizations',
    focusSection: 'extensions',
    organizationId,
  })
}

/** Workspace Settings > extension page (e.g. google-drive, cursor). */
export function openWorkspaceExtensionSettings(
  extensionId: string,
  organizationId?: string,
) {
  openSettings({
    tab: 'organizations',
    focusSection: `extension:${extensionId}`,
    organizationId,
  })
}
